<template>
  <div :class="['backing', backgroundStyle]">
    <font-awesome-icon 
      class="pi-icon"
      icon="fa-solid fa-circle-user" />
  </div>
</template>

<script>
export default {
  props: ["backgroundStyle"],
}
</script>

<style scoped>
  .backing {
    padding: 2px 4px;
    position: absolute;
    top: calc(-100% + 10px);
    left: 0;
    border-radius: 4px 4px 0 0;
  }

  .pi-icon {
    color: #5ED295;
  }

  .position-label--gk-row {
    background: #615C50;
  }
  .position-label--d-row {
    background: #3D75A4;
  }
  .position-label--dm-row {
    background: #687581;
  }
  .position-label--m-row {
    background: #44515C;
  }
  .position-label--am-row {
    background: #252E34;
  }
  .position-label--st-row {
    background: #655984;
  }
</style>
